import { render } from "./DateRange.vue?vue&type=template&id=195b85e0"
import script from "./DateRange.vue?vue&type=script&lang=js"
export * from "./DateRange.vue?vue&type=script&lang=js"

import "./DateRange.vue?vue&type=style&index=0&id=195b85e0&lang=css"
script.render = render

export default script